/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import {
	Body,
	Container,
	Title,
	SubTitle,
	Button,
	ButtonsContainer,
	Header
} from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { pwaAssets } from "assets/cdn";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { usePushNotificationsContext } from "contexts/PushNotificationsProvider";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useImagePath } from "hooks/useImagePath";

interface PushPermissionsPopupProps {}

export const PushPermissionsPopup: React.FC<PushPermissionsPopupProps> = () => {
	const { getImage } = useImagePath("cdn");
	const backgroundImage = getImage(pwaAssets.pushPermissionsBackground);
	const isPortrait = useMediaQuery("(orientation: portrait)");

	const { close, open } = usePopUpsV2();
	const { subscribe, pushLocalState, setPushLocalState } =
		usePushNotificationsContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_push_optin_prompt_shown",
			event_type: "pwa_push_option_prompt",
			action: "shown",
			source: "pwa_push",
			page_location: window.location.pathname
		});
		// Only fire once on mount
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const scale = useCalculateScale(
		isPortrait ? 363 + 40 : 956 + 40,
		isPortrait ? 613 + 40 : 410 + 40
	);

	const onClose = () => {
		//dispatch(onClosePopUp());
		close({ variant: "push-permissions-popup" });
	};

	const reportClickEvent = (type: "allow" | "not_allow") => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_push_optin_click",
			event_type: "pwa_push_option_prompt",
			action: "clicked",
			source: "pwa_push",
			type,
			page_location: window.location.pathname
		});
	};

	const handleClickAllow = async () => {
		reportClickEvent("allow");
		onClose();

		await subscribe();

		const effectivePermission: NotificationPermission | "unsupported" =
			typeof Notification === "undefined"
				? "unsupported"
				: Notification.permission;

		if (effectivePermission === "denied") {
			open({
				variant: "push-info-popup",
				id: "push-info-popup",
				replaceIfExists: true
			});
		}
	};

	const handleClickNotNow = () => {
		reportClickEvent("not_allow");
		setPushLocalState({
			...(pushLocalState ?? {}),
			neverShowPopup: true
		});
		onClose();
	};

	return (
		<Container scale={scale}>
			{/* <CloseIconButton onClose={onClose} /> */}
			<Header style={{ backgroundImage: `url(${backgroundImage})` }} />
			<Body>
				<Title>
					<div>Stay in the Loop!</div>
				</Title>

				<SubTitle>
					Get notified about new rewards, sales, and exciting updates! Never
					miss out on your Daily Gifts.
				</SubTitle>
				<ButtonsContainer>
					<Button
						variant="contained"
						themeColor="primary"
						onClick={handleClickAllow}
					>
						Allow
					</Button>
					<Button
						variant="contained"
						themeColor="secondary"
						onClick={handleClickNotNow}
					>
						Not now
					</Button>
				</ButtonsContainer>
			</Body>
		</Container>
	);
};
